import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function MfaVerify() {
  const [code, setCode] = useState("");
  const { refresh, logout } = useAuth();
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/mfa/verify", { code });
      await refresh();
      navigate("/app", { replace: true });
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="grid min-h-screen place-items-center bg-[#0B192C] px-4">
      <form onSubmit={submit} className="card w-full max-w-sm p-8" data-testid="mfa-verify-form">
        <h1 className="text-xl font-bold text-[#0B192C]">Two-step verification</h1>
        <p className="mt-2 text-sm text-slate-600">Enter the 6-digit code from your authenticator app.</p>
        <label htmlFor="mfa-code" className="label mt-6">Code</label>
        <input id="mfa-code" inputMode="numeric" autoComplete="one-time-code" maxLength={6} data-testid="mfa-code-input" className="input font-mono text-lg tracking-widest" value={code} onChange={(e) => setCode(e.target.value)} />
        <button type="submit" data-testid="mfa-verify-button" className="btn-teal mt-6 w-full">Verify</button>
        <button type="button" onClick={logout} className="mt-3 w-full text-xs text-slate-500 hover:underline">Sign out</button>
      </form>
    </div>
  );
}
